module.exports = __webpack_public_path__ + "img/text-with-button.51235a0a.png";